var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.83334 5.83335H5.84167M17.1583 11.175L11.1833 17.15C11.0286 17.305 10.8447 17.4279 10.6424 17.5118C10.4401 17.5957 10.2232 17.6388 10.0042 17.6388C9.78515 17.6388 9.56827 17.5957 9.36594 17.5118C9.16361 17.4279 8.97979 17.305 8.82501 17.15L1.66667 10V1.66669H10L17.1583 8.82502C17.4688 9.13729 17.643 9.55971 17.643 10C17.643 10.4403 17.4688 10.8627 17.1583 11.175Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTag);
export default __webpack_public_path__ + "static/media/tag.31492eb646c3230ef84bc3b5f509a9ce.svg";
export { ForwardRef as ReactComponent };